module.exports=function(scope){ return `<!-- image missing in request -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "You must pass image parameter."
    }
}

<!-- empty image -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "Empty string not valid for parameter image."
    }
}


<!-- image are less then 20 characters -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "Source data length is < 20."
    }
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/restsdk-v2/response/failure/facemap-post.json.tpl